/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Descriptionotp1Inputs */

const he_auth_login_descriptionotp1 = /** @type {(inputs: Auth_Login_Descriptionotp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזינו אימייל לקבלת קוד חד-פעמי להתחברות.`)
};

const en_auth_login_descriptionotp1 = /** @type {(inputs: Auth_Login_Descriptionotp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email to receive a one-time sign-in code.`)
};

/**
* | output |
* | --- |
* | "Enter your email to receive a one-time sign-in code." |
*
* @param {Auth_Login_Descriptionotp1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_login_descriptionotp1 = /** @type {((inputs?: Auth_Login_Descriptionotp1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Descriptionotp1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_login_descriptionotp1(inputs)
	return en_auth_login_descriptionotp1(inputs)
});
export { auth_login_descriptionotp1 as "auth_login_descriptionOtp" }